import React, { useState, useEffect, useContext, createContext } from "react";
import {
  getDomain,
  getAllSubcontractor,
  updateSubContractor,
  deleteSubContractor, addCustomerToQuickBooks
} from "../../webServices/Apis";
import { AiFillDelete, AiFillEdit, AiOutlineEye } from "react-icons/ai";
import { message } from "antd";
import Loader from "../Loader/Loader";
import AddSubContracter from "./AddSubContracter";
import ViewSubContracter from "./ViewSubContracter";
import EditSubContracter from "./EditSubContracter";
import { useNavigate } from "react-router";
import { UserContext } from "../../App";
import { Pagination, Tooltip } from 'antd';
import CustomModal from "../Modals/CustomModal";
import { FaSearch } from 'react-icons/fa';
import noProfile from '../../images/noProfile.jpg'


// create context to transfer contractors
export const subContractorContext = createContext();

function SubContractor() {
  const navigate = useNavigate();
  const { setIsAuthenticated } = useContext(UserContext);
  const [subContractors, setSubContractors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddContracter, setShowAddContracter] = useState(false);
  const [action, setAction] = useState(false);
  const [showSubContracter, setShowSubContracter] = useState(false);
  const [selectedSubContracter, setSelectedSubContracter] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [showEditSubContracter, setShowEditSubContracter] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [subContractorToDelete, setSubContractorToDelete] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");



  // const fetchDomainAgain = async () => {
  //   try {
  //     const response = await getDomain();
  //     if (response?.data?.data) {
  //       setDomain(response?.data?.data)
  //     }
  //   } catch (error) {
  //     console.log("Domain Error", error.message)
  //   }
  // }


  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleCreateModalOpen = () => {
    setShowAddContracter(true);
  };

  const handleDetailsModalOpen = (subContractor) => {
    setSelectedSubContracter(subContractor);
    setShowSubContracter(true);
  };

  const handleUpdateSubContractor = (subContractor) => {
    setSelectedSubContracter(subContractor);
    setShowEditSubContracter(true);
  };


  const filteredSubcontractor = subContractors.filter((user) => {
    const query = searchQuery.toLowerCase();
    return (
      (user.firstName && user.firstName.toLowerCase().includes(query)) ||
      (user.email && user.email.toLowerCase().includes(query))
    );
  });

  const getSubcontractors = async () => {
    setLoading(true);
    try {
      const response = await getAllSubcontractor();
      const reverseSubcontractors = [...response?.data?.data].reverse();
      if (response?.data?.success) {
        // setSubContractors(response?.data?.data);
        setSubContractors(reverseSubcontractors);

      }
    } catch (error) {
      console.log("Error fetching subcontractors:", error);
      if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert("Your account is logged in to another device, please login again !")
        localStorage.removeItem('token');
        setIsAuthenticated(false)
        window.location.href = "/login";
        return;
      }
      
      if (error?.response?.status === 500) {
        message.error("Server not responding")
        return;
      }
      if (error?.response?.status === 403) {
        window.alert("Your subcription has been expired")
        localStorage.clear()
        setIsAuthenticated(false)
        window.location.href = "/login";
        return;
      }
      else {
        return;
      }

    } finally {
      setLoading(false);
    }
  };

  const hanldeDelete = async () => {
    if (!subContractorToDelete) return;

    try {
      const response = await deleteSubContractor(subContractorToDelete);
      if (response.data.success) {
        setAction(!action);
        message.success(response?.data?.message);
        setShowDeleteModal(false);
      }
    } catch (error) {
      console.log("Error while deleting subcontractor", error);
      message.error("Error while deleting subcontractor");
    }
  };

  const handleDeleteSubContracter = (subContracterDetails) => {
    setSubContractorToDelete(subContracterDetails.id);
    setShowDeleteModal(true);
  };

  const closeDeleteModel = () => {
    setShowDeleteModal(false)
    setSubContractorToDelete(null)
  }

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1)
  };

  useEffect(() => {
    getSubcontractors();
  }, [action]);

  // Slice the subcontractors based on current page and items per page
  const currentItems = filteredSubcontractor.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <subContractorContext.Provider value={{ subContractors, setSubContractors }}>
      <div className="p-4">
        <div className="flex flex-row justify-between items-center">
          {loading && <Loader />}
          <div className="relative w-1/3 flex">
            <input
              type="text"
              placeholder="Search Subcontractors..."
              className="w-3/4 p-3 border-4 border-gray-500 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              // value={searchQuery}
              onChange={handleSearch} // Update the state on input change
            />
            <FaSearch className="absolute left-2/3 top-3 text-gray-800 h-5 w-5 cursor-pointer mt-2  " />
          </div>

          <div>
            {currentItems?.some((subContractor) => subContractor?.authorised === false) && (
              <div className="flex justify-center bg-red-100 text-red-500 p-4 mt-4 rounded border-2 border-red-800">
                <p className=" text-center font-bold">All subcontractors are in De-Authorized mode !</p>
              </div>
            )}
          </div>

          <div className="flex justify-end items-end">
            <button
              onClick={handleCreateModalOpen}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-12 rounded"
            >
              Create
            </button>
          </div>
        </div>

        {/* Subcontractor Table */}
        <table className="min-w-full mt-7 bg-white border border-b-4 border-black">
          <thead>
            <tr className="bg-gray-800 text-white">
              <th className="py-2 px-4 border-b text-center">S.No</th>
              <th className="py-2 px-4 border-b text-center">Profile Pic</th>
              <th className="py-2 px-4 border-b text-center">Name</th>
              <th className="py-2 px-4 border-b text-center">Email</th>
              {/* <th className="py-2 px-4 border-b text-center">Company Name</th> */}
              <th className="py-2 px-4 border-b text-center">Status</th>
              <th className="py-2 px-4 border-b text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentItems?.length > 0 ? (
              currentItems?.map((subContractor, index) => (
                <tr
                  key={subContractor.id}
                  className={`hover:bg-gray-200 text-center transition duration-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-300'}`}
                >
                  <td className="py-2 px-4 border-b">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td className="py-2 px-4 border-b">
                    <div className="flex items-center justify-center">
                      {subContractor?.profileImage ? <img
                        src={subContractor?.profileImage}
                        alt="subcontractor"
                        className="w-30 h-24 object-cover mr-2 border border-gray-700"
                        style={{ height: "50px", width: "50px", borderRadius: "50%" }}
                      /> :
                        <img
                          src={noProfile}
                          alt="subcontractor"
                          className="w-30 h-24 object-cover mr-2 border border-gray-700"
                          style={{ height: "50px", width: "50px", borderRadius: "50%" }}
                        />}
                    </div>
                  </td>
                  <td className="py-2 px-4 border-b">{subContractor.firstName}</td>
                  <td className="py-2 px-4 border-b">{subContractor.email}</td>
                  {/* <td className="py-2 px-4 border-b">{subContractor.companyName}</td> */}
                  <td className="py-2 px-4 border-b">
                    <span className={`py-0.5 px-2 text-[20px] font-medium w-fit ${subContractor.active ? "text-green-500" : "text-red-500"}`}>
                      {subContractor.active ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td className="py-2 px-4 border-b">
                    <div className="flex flex-row justify-center">
                      <button
                        onClick={() => handleDetailsModalOpen(subContractor)}
                        className="text-blue-500 hover:text-blue-700 flex items-center"
                      >
                        <AiOutlineEye className="mr-1 text-xl" />
                      </button>
                      <button
                        onClick={() => handleUpdateSubContractor(subContractor)}
                        className="mr-2 text-blue-500 hover:text-blue-700 flex items-center"
                      >
                        <AiFillEdit className="mr-1 text-xl" />
                      </button>
                      <button
                        onClick={() => handleDeleteSubContracter(subContractor)}
                        className="text-red-500 hover:text-red-700 flex items-center"
                      >
                        <AiFillDelete className="mr-1 text-xl" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="py-2 px-4 border-b text-center">No Subcontractor Found</td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="mt-4 flex justify-end">
          <Pagination
            current={currentPage}
            total={subContractors.length}
            pageSize={itemsPerPage}
            onChange={handlePageChange}
            showSizeChanger={false}
          />
        </div>

        {/* Modals for Add, View, Edit, and Delete */}
        {showSubContracter && (
          <ViewSubContracter
            showSubContracter={showSubContracter}
            setShowSubContracter={setShowSubContracter}
            selectedSubContracter={selectedSubContracter}
          />
        )}

        {showAddContracter && (
          <AddSubContracter
            showAddContracter={showAddContracter}
            setShowAddContracter={setShowAddContracter}
            action={action}
            setAction={setAction}
          />
        )}

        {showEditSubContracter && (
          <EditSubContracter
            showEditSubContracter={showEditSubContracter}
            setShowEditSubContracter={setShowEditSubContracter}
            action={action}
            setAction={setAction}
            selectedSubContracter={selectedSubContracter}
          />
        )}


        <CustomModal
          isOpen={showDeleteModal}
          title="Confirm Delete"
          message="Are you sure you want to delete this sub contractor ?"
          onConfirm={hanldeDelete}
          onClose={closeDeleteModel}
        />

      </div>
    </subContractorContext.Provider>
  );
}

export default SubContractor;
